module.exports = __webpack_public_path__ + "img/valve-alu.7e962429.jpg";